module.exports = __webpack_public_path__ + "img/three-tiao@3x.953ce1c9.png";